import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    background-color: var(--lighter-grey);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: var(--spacing-xl, 24px);
    margin: var(--spacing-xl, 24px) 0 0 0;
  `,
  title: css`
    font-size: 14px;
    color: var(--dark-grey);
  `,
}

type EmptyProps = { title?: string; className?: string }

export function Empty(props: EmptyProps) {
  const { title = "No data to display", className } = props
  return (
    <div className={cx(styles.root, className)}>
      <span className={cx(styles.title)}>{title}</span>
    </div>
  )
}
